import {
  ChevronRight,
  Construction,
  ErrorOutlineRounded,
} from '@mui/icons-material'

import styles from './LkmAppealDetail.module.scss'
import { useNavigate, useParams } from 'react-router'
import { LoaderInCentalPosition } from 'widget'
import { DropDownBlock } from 'feature/appeals/components/DropDownBlock/DropDownBlock'
import { LkmAppealDetailInfo } from '../lkmAppealDetailInfo'
import { Button } from 'ui'
import { LkmAppealDetailService } from '../lkmAppealDetailService'
import { useGetLkmAppealQuery } from 'feature/lkmAppeals/redux/LkmAppeals.api'
import { InformationCard } from 'feature/informationCard'

export const LkmAppealDetail = () => {
  const params = useParams()
  const navigate = useNavigate()
  const appealUid = params.id

  const { data, isFetching } = useGetLkmAppealQuery({
    claimId: appealUid ?? '',
  })

  const handleGoBack = () => {
    navigate(-1)
  }

  if (isFetching && !data) return <LoaderInCentalPosition />
  if (!data)
    return (
      <InformationCard
        title='монтаж не найден'
        subtitle='Возможно, загруженная ссылка некорректна'
        Icon={<ErrorOutlineRounded fontSize='large' color='primary' />}
        link='/orders'
        linkText='Мои монтажи'
      />
    )

  const appeal = data.result

  return (
    <div className={styles.appealsList}>
      <Button
        onClick={handleGoBack}
        variant='text'
        className={styles.backButton}
        color='primary'
        startIcon={<ChevronRight color='primary' className='rotate180' />}
        data-testid='lkm-detail-back-btn'
      >
        Назад
      </Button>
      <div className={styles.appealsList__title}>
        <Construction color='primary' />

        <h1>{appeal.name}</h1>
      </div>

      <DropDownBlock
        title='состав заказа'
        isOpen
        testId='lkm-detail-composition-toggle'
      >
        <LkmAppealDetailInfo
          data={appeal}
          isClientVisible={appeal.confirmation}
        />
      </DropDownBlock>
      <DropDownBlock
        title='Монтаж'
        isOpen={appeal.confirmation}
        testId='lkm-detail-service-toggle'
      >
        {appeal.confirmation && <LkmAppealDetailService data={appeal} />}
      </DropDownBlock>
    </div>
  )
}
